type DetailedFeatureItemProps = {
    image: string;
    title: string;
    text: string;
    backgroundClass?: string;
    index: number;
};

const DetailedFeatureItem: React.FC<DetailedFeatureItemProps> = ({ image, title, text, backgroundClass, index }) => {
    return (
        <div className={`p-[25px] pb-[35px] xl:p-[75px] grid grid-cols-1 xl:grid-cols-2 ${backgroundClass} items-center gap-[33px] xl:gap-[60px]`}>
            {/* Image */}
            <div className={`order-1 grid-1 ${index % 2 !== 0 ? 'xl:order-2' : ''} flex items-center justify-center`}>
                <img src={image} alt={title} className="h-full w-auto max-w-[250px] sm:max-w-[350px] lg:max-w-[550px] xl:max-w-[400px] 2xl:max-w-[550px] mx-auto" />
            </div>

            {/* Text */}
            <div className={`flex flex-col gap-4 justify-start order-2 ${index % 2 !== 0 ? 'xl:order-1' : ''}`}>
                <div className="relative w-fit mx-auto xl:ml-0">
                    <div className={`h-fit relative z-20 xl:bg-#FFFFFF w-fit px-4 py-2 rounded-[10px] flex gap-[12px] items-center border border-white/30 ${index % 2 === 0 ? 'bg-[#FF61041A] backdrop-blur-[8px]' : 'bg-#FFFFFF'}`}>
                        <div className={`w-[34px] h-[34px] bg-[#FF8E5F] rounded-full flex-shrink-0 ${index % 2 === 0 ? 'hidden xl:block' : ''}`} />
                        <h2 className={`text-xl xl:text-2xl font-bold text-[#333333] ${index % 2 === 0 ? 'pl-[10px]' : ''}`}>{title}</h2>
                    </div>
                    {index % 2 === 0 && (
                        <div className="block xl:hidden w-[34px] h-[34px] bg-[#FF8E5F] rounded-full flex-shrink-0 z-10 absolute -bottom-[5px] -left-[15px]" />
                    )}
                </div>
                <p className="text-base xl:text-lg text-[#333333] sm:px-[30px] md:px-[50px] xl:pl-[30px] xl:pr-0 xl:border-[#FF9800] xl:border-l-4">{text}</p>
            </div>
        </div>
    );
};

export default DetailedFeatureItem;